export function autoClickIziButtonIfCurrencyRestored(currencyWasRestored) {
  if (!currencyWasRestored) return;

  let searchAttempt = 0;
  const maxSearchAttempts = 30;

  const searchInterval = setInterval(() => {
    const allButtons = document.querySelectorAll("inpost-izi-button");

    if (allButtons.length > 0) {
      clearInterval(searchInterval);

      allButtons.forEach((button) => {
        let buttonAttempt = 0;
        const maxButtonAttempts = 30;

        const buttonInterval = setInterval(() => {
          if (button.shadowRoot) {
            clearInterval(buttonInterval);

            const innerButton = button.shadowRoot.querySelector(".button");
            if (innerButton) {
              button.setAttribute("data-currency-processed", "1");
              innerButton.click();
            }
          } else if (++buttonAttempt >= maxButtonAttempts) {
            clearInterval(buttonInterval);
          }
        }, 200);
      });
    } else if (++searchAttempt >= maxSearchAttempts) {
      clearInterval(searchInterval);
    }
  }, 300);
}
